import {Offcanvas} from "bootstrap";
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination, EffectFade} from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    /**
     * Detect javascript
     */
    if (document.body.classList.contains('no-js')) document.body.classList.remove('no-js');

    const menuOffcanvasTrigger = document.getElementById('menuOffcanvasTrigger');
    const menuOffcanvas = document.getElementById('menuOffcanvas');
    if (menuOffcanvasTrigger && menuOffcanvas) {
        menuOffcanvasTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            const bsOffcanvas = new Offcanvas(menuOffcanvas);
            bsOffcanvas.toggle();
        });
    }

    /**
     * Handle btn-filter click
     */
    document.body.addEventListener('click', (e) => {
        if (e.target.closest('.btn-filter')) {
            e.preventDefault();
            e.target.classList.toggle('active');
        }
    });

    /**
     * Init swiper
     * @type {Swiper}
     */
    const heroCarousel = new Swiper('.hero-carousel', {
        // configure Swiper to use modules
        modules: [Navigation, Pagination, Autoplay],
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // Paginazione
        pagination: {
            el: '.swiper-pagination',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
                // Funzione per aggiungere lo zero iniziale
                return current < 10 ? '0' + current : current;
            }
        },

        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
    });

    if (typeof heroCarousel.el == "object") {
        // Fermare autoplay su tocco (mobile)
        heroCarousel.el.addEventListener('touchstart', () => {
            heroCarousel.autoplay.stop();
        });

        heroCarousel.el.addEventListener('touchend', () => {
            heroCarousel.autoplay.start();
        });
    }

    const alerts = new Swiper('.alerts', {
        modules: [Autoplay, EffectFade],
        slidesPerView: 1,
        effect: 'fade',
        speed: 800,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
    });
});
